import {
  createReducer,
  createRequestReducer
} from 'utils';

import { GET_POST_TAGS } from './constants';

const initialState = {
  results: [],
  isFetching: false,
  fetchingErrors: null
};

export default createReducer(initialState, {
  [GET_POST_TAGS]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state, action) =>
        Object.assign(state, {
          results: [],
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        return Object.assign(state, {
          results: action.request.response.results,
          isFetching: false
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/PostTags/reducer.js